const STATIC_BASE = (process.env.REACT_APP_STATIC_BASE_URL || "").replace(/\/$/, "");

export const resolveMediaUrl = (path) => {
  if (!path) return "";

  // already absolute
  if (/^https?:\/\//i.test(path)) return path;

  // path should already start with /uploads
  return `${STATIC_BASE}${path}`;
};
